import Column from '@sdk/components/ui/spacing/Column';
import H3 from '@sdk/components/ui/typography/H3';
import Text16 from '@sdk/components/ui/typography/Text16';
import Row from '@sdk/components/ui/spacing/Row';
import Padding from '@sdk/components/ui/spacing/Padding';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import Avatar from '@kiosk/common/components/Avatar';

import { getGreeting } from './userAvatar.utils';

type Props = {
  avatar?: string;
  name: string;
  lastname: string;
  subText: string;
};

const UserAvatar = ({ avatar, name, lastname, subText }: Props) => {
  return (
    <Row alignItems="center">
      <Padding right={12}>
        <Avatar avatar={avatar} name={name} lastname={lastname} />
      </Padding>
      <Column pLeft={12}>
        <H3 bold>{`${getGreeting()}, ${name}!`}</H3>
        <Text16 themeColor={ThemeColorType.iconGray} bold>
          {subText}
        </Text16>
      </Column>
    </Row>
  );
};

export default UserAvatar;
